import axios from "axios";

export default function ReceiptListService(queryOrParams) {
  let query = queryOrParams;
  try {
    if (typeof queryOrParams === 'string' && queryOrParams.trim().startsWith('{')) {
      const parsed = JSON.parse(queryOrParams);

      if (window.App && typeof window.App.transformQueryParams === 'function') {
        query = window.App.transformQueryParams(parsed);
      } else {
        query = queryOrParams;
      }
    } else if (typeof queryOrParams === 'object' && queryOrParams !== null) {
      if (window.App && typeof window.App.transformQueryParams === 'function') {
        query = window.App.transformQueryParams(queryOrParams);
      } else {
        query = JSON.stringify(queryOrParams);
      }
    }
  } catch (e) {
    console.error('ReceiptListService query transform error:', e);
    query = queryOrParams;
  }
  if (query && query.toString().includes(',"multiSortMeta":[]')) {
    query = query.replace(',"multiSortMeta":[]', '');
  }
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/api/v2/receipt?" + query,
    params: {},
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    }
  });
}
